import type { BotDifficulty } from '@caged/shared';

export interface Settings {
  language: string;
  musicVolume: number;
  sfxVolume: number;
  muted: boolean;
  /** Follows the OS setting unless the player changes it. */
  reducedMotion: boolean;
  vibration: boolean;
  difficulty: BotDifficulty;
  /**
   * The account's name and fighter, as last heard from the server (D55, docs/architecture.md §8):
   * every sync replaces them with the server's, and fights use the server's. Picked in Profile
   * (store.pickName, pickFighter); a device without an account keeps its own.
   */
  playerName: string;
  fighterId: string;
}

const KEY = 'caged.settings.v1';

export function defaultSettings(): Settings {
  const reduced =
    typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  return {
    language: 'en',
    musicVolume: 0.5,
    sfxVolume: 0.8,
    muted: false,
    reducedMotion: reduced,
    vibration: true,
    difficulty: 'normal',
    playerName: '',
    fighterId: 'spike',
  };
}

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...defaultSettings(), ...(JSON.parse(raw) as Partial<Settings>) };
  } catch {
    // ignore
  }
  return defaultSettings();
}

export function saveSettings(s: Settings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    // ignore
  }
}
